import Image from 'next/image';
import { useMemo } from 'react';

import { LOCALSTORAGE_SOCIAL_REDIRECT_KEY } from '@/utils/const';
import fbLogo from 'public/icons/socials-facebook.svg';
import googleLogo from 'public/icons/socials-google.svg';

import styles from './styles.module.scss';
import { Props } from './types';

const SocialLogin = ({ redirectUrl }: Props) => {
  const medusa_url = process.env.NEXT_PUBLIC_SERVER_URL;
  const authPathGoogle = 'store/auth/google';
  const authPathFb = 'store/auth/facebook';

  const saveRedirectUrl = () => {
    if (redirectUrl) {
      localStorage.setItem(LOCALSTORAGE_SOCIAL_REDIRECT_KEY, redirectUrl);
    }
  };

  const googleAuthHref = useMemo(() => {
    const baseUrl = `${medusa_url}/${authPathGoogle}`;
    if (!redirectUrl) return baseUrl;
    const currentUrl = new URL(baseUrl);
    const redirectTo = `${window.location.origin}${redirectUrl}`;
    currentUrl.searchParams.append('redirectTo', redirectTo);
    return currentUrl.toString();
  }, [medusa_url, redirectUrl]);

  return (
    <div className={styles.container}>
      {/* TODO: Delete after fix Facebook login */}
      {/* <a
        type="button"
        href={`${medusa_url}/${authPathFb}`}
        onClick={saveRedirectUrl}
        className={styles.button}
      >
        <Image src={fbLogo} alt="Ikona Facebook" width={24} height={24} />
        <p>Facebook</p>
      </a> */}
      <a
        type="button"
        href={googleAuthHref}
        onClick={saveRedirectUrl}
        className={styles.button}
      >
        <Image src={googleLogo} alt="Ikona Google" width={24} height={24} />
        <p>Google</p>
      </a>
    </div>
  );
};

export default SocialLogin;
